export default __webpack_public_path__ + "static/media/experience.50667a45.png";